import gql from 'graphql-tag';
import { type ApolloError, useQuery } from '@apollo/react-hooks';

export const useGetNeedVisa = (
  applicationId: string,
): {
  needVisa: boolean;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data, loading, error } = useQuery(
    gql`
      query ($applicationId: String!) {
        needStudentVisa(applicationId: $applicationId)
      }
    `,
    {
      variables: { applicationId },
    },
  );

  return {
    needVisa: data?.needStudentVisa,
    loading,
    error,
  };
};
